/**
 * Client-side skill slug helpers. Keep in sync with `server/utils/skill-catalog.js`.
 * Empty / `__untagged` values stay empty — never persist them as skills.
 */
export const UNTAGGED_SKILL_KEY = '__untagged';
export const SKILL_SELECT_NONE = '__none';
export const SKILL_SLUG_MAX_LEN = 200;
export const SKILL_LABEL_MAX_LEN = 200;
export function isReservedSkillKey(value) {
    if (value == null)
        return false;
    return String(value).trim().toLowerCase() === UNTAGGED_SKILL_KEY;
}
export function slugifySkillKey(raw) {
    if (raw == null)
        return null;
    const s = String(raw)
        .trim()
        .toLowerCase()
        .replace(/['’]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, SKILL_SLUG_MAX_LEN);
    if (!s || isReservedSkillKey(s) || s === SKILL_SELECT_NONE)
        return null;
    return s;
}
export function sanitizeSkillCodesClient(raw) {
    if (!Array.isArray(raw))
        return [];
    const codes = [];
    const seen = new Set();
    for (const item of raw) {
        const slug = slugifySkillKey(item);
        if (!slug || seen.has(slug))
            continue;
        seen.add(slug);
        codes.push(slug);
        if (codes.length >= 24)
            break;
    }
    return codes;
}
export function sanitizeSkillLabelClient(raw) {
    if (typeof raw !== 'string')
        return null;
    const label = raw.trim().slice(0, SKILL_LABEL_MAX_LEN);
    if (!label || isReservedSkillKey(label))
        return null;
    return label;
}
/** Persistable skill_label + skill_codes for question JSON. Empty / untagged stay omitted. */
export function skillTagsFromQuestion(question) {
    const label = sanitizeSkillLabelClient(question?.skill_label);
    const codes = sanitizeSkillCodesClient(question?.skill_codes);
    const out = {};
    if (label)
        out.skill_label = label;
    if (codes.length) {
        out.skill_codes = codes;
    }
    else if (label) {
        const slug = slugifySkillKey(label);
        if (slug)
            out.skill_codes = [slug];
    }
    return out;
}
